import { render, staticRenderFns } from "./subjectChoose.vue?vue&type=template&id=33b79a6b&"
import script from "./subjectChoose.vue?vue&type=script&lang=js&"
export * from "./subjectChoose.vue?vue&type=script&lang=js&"
import style0 from "./subjectChoose.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports